import { LazyLoading } from "@b2bportal/core-ui";
import type { ShopPage } from "@tenant/cars";
import { PackagesCarSlotProvider } from "../../slots";

export const PackageCarsShopPage = (
  props: React.ComponentProps<typeof ShopPage>
) => {
  // This page is only used to show a loader while fetchPackageCarsShop completes.
  // The actual data fetching happens in the route via usePackageCarsShopPageFetch.
  // Once the fetch completes, the user can proceed to checkout.
  return <LazyLoading />;

  // Original implementation commented out - kept for reference
  // return (
  //   <PackagesCarSlotProvider>
  //     <ShopPage {...props}> </ShopPage>
  //   </PackagesCarSlotProvider>
  // );
};
